module.exports = __webpack_public_path__ + "website/img/core4_2.f70d3cd6.png";